import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { RouteService } from '../route.service';
import { FormControl } from '@angular/forms';
import { ProgressSpinnerMode, ThemePalette } from '@angular/material';
import { AmazingTimePickerService } from 'amazing-time-picker';


@Component({
  selector: 'app-route-time-change',
  templateUrl: './route-time-change.component.html',
  styleUrls: ['./route-time-change.component.scss']
})
export class RouteTimeChangeComponent implements OnInit {
  dataSource: any;
  data_loaded = false;
  displayedColumns: string[] = ['id', 'name', 'union', 'session', 'order_expiry_time'];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 100;
  mor_route_time = '17:00:00';
  eve_route_time = '08:00:00';
  nameFilter = new FormControl('');
  filterValues = {
    id: '',
    name: '',
    session: '',
  };
  title = null;
  constructor(private global: GlobalService, private http: HttpService, public routeService: RouteService, private atp: AmazingTimePickerService) {
    this.global.set_master_page_title = 'Route';
    this.title = this.global._active_display_name;
    this.getRoute();
    this.routeService.downloadRoute.subscribe((route) => {
      console.log(route);
      if (route) {
        this.getRoute();
      }
    });
  }

  changeAllRoute(session_id) {
    console.log(session_id);
    let route_time = null;
    if (session_id === 1) {
      route_time = this.mor_route_time;
    } else {
      route_time = this.eve_route_time;
    }
    let data_dict = {
      'session_id': session_id,
      'route_time': route_time,
    };
    if (confirm('Are you sure Want To Change Time ?')) {
      this.http.channgeOverallRouteExpiryTime(data_dict).subscribe((data) => {
        console.log(data);
        this.global.showSnakeBar('Route Time Updated !!');
        this.getRoute();
      }, (error) => {
        console.error(error);
      });
    }
  }


  timeValueChanged(route) {
    console.log(route);
    this.http.channgeRouteExpiryTime(route).subscribe((data) => {
      console.log(data);
      this.global.showSnakeBar('Route Time Updated !!');
    }, (error) => {
      console.error(error);
    });
  }

  getRoute() {
    this.http.getRoute().subscribe((data: Route[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<Route>(data);
      this.dataSource.sort = this.sort;
      this.dataSource = data;
      this.dataSource.filterPredicate = this.createFilter();
      this.data_loaded = true;
    }, (error) => {
      this.data_loaded = true;
      console.log(error);
    });
  }


  ngOnInit() {
    console.log('ng funct');
    this.nameFilter.valueChanges
      .subscribe(
        name => {
          this.filterValues.name = name;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
  }

  createFilter():
    (data: any, filter: string) => boolean {
    console.log('filter')
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.name.toString().toLowerCase().indexOf(searchTerms.name.toString().toLowerCase()) !== -1
    }
    return filterFunction;
  }



}
export interface Route {
  id: number;
  name: string;
}
